'use strict';

var angularModule = angular.module('t2g.common.data-access.messages', []);

module.exports = angularModule;

angularModule.factory('MessageResource', function($resource, settings) {
  var resourceUrl = settings.apiBase + '/api/v2/office/:officeId/message/:messageId';

  var resource = $resource(
    resourceUrl,
    { messageId: '@_id', officeId: '@office' },
    {
      getAll: { method: 'GET', isArray: false },
      getOne: { method: 'GET', isArray: false },
    },
  );

  return resource;
});

angularModule.factory('Message', function($q, MessageResource, UserSession) {
  return {
    get: function(box) {
      var deferred = $q.defer();

      MessageResource.getAll({ box: box, officeId: UserSession.getOffice() }).$promise.then(
        function(response) {
          deferred.resolve(response.messages);
        },
        function(error) {
          deferred.reject(error);
        },
      );
      return deferred.promise;
    },
    getOne: function(messageId) {
      var deferred = $q.defer();

      MessageResource.getOne({
        messageId: messageId,
        officeId: UserSession.getOffice(),
      }).$promise.then(
        function(response) {
          deferred.resolve(response.message);
        },
        function(error) {
          deferred.reject(error);
        },
      );

      return deferred.promise;
    },
    delete: function(message) {
      var message = new MessageResource(message);

      return message.$delete();
    },
  };
});



// WEBPACK FOOTER //
// ./src/app/common/data-access/messages.js